function memoize(run) {
    const promiseCache = new Map();
    const memoized = async function (...args) {
        const promiseKey = JSON.stringify(args);
        const cachedPromise = promiseCache.get(promiseKey);
        if (cachedPromise) {
            return cachedPromise;
        }
        const promise = (async () => {
            try {
                return await run.apply(this, args);
            }
            finally {
                promiseCache.delete(promiseKey);
            }
        })();
        promiseCache.set(promiseKey, promise);
        return promise;
    };
    return memoized;
}

export { memoize };
